export const getWaypointIconAnchor = (name: string): [number, number] => {
  if (name.startsWith("map_icon")) return [16, 37];
  if (name.startsWith("map_shape")) return [9, 9];
  return [22, 44];
};
